export interface GLOptionalCoverageIndicator {
  /** codeName of the boolean Policy attribute that indicates this optional coverage was suggested */
  indicatorCodeName: string;
  /** codeName of the boolean Policy attribute that records broker acceptance of the coverage */
  acceptedCodeName: string;
  /** label shown in the "Coverage" column when the indicator is true */
  label: string;
  /** coverage.coverageName used to look up the reporting coverage's TermPremium */
  coverageName: string;
}

/**
 * Add an entry here for each new optional coverage that should surface in the
 * "General Liability Optional Coverages" section on the Bind page.
 */
export const glOptionalCoverageIndicators: GLOptionalCoverageIndicator[] = [
  {
    indicatorCodeName: 'GLPolicyAggregateDeductibleInd',
    acceptedCodeName: 'GLPolicyAggregateDeductibleCoverageAccepted',
    label: 'Deductible Policy Aggregate',
    coverageName: 'Deductible Policy Aggregate - Reporting',
  },
];
